import { Modal, Box, Button, Slide, Typography, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Trans } from "@lingui/react/macro";

interface OfferzPlusTCProps {
  openTermsModal: boolean;
  setOpenTermsModal: (openTermsModal: boolean) => void;
}
const OfferzPlusTC: React.FC<OfferzPlusTCProps> = ({ openTermsModal, setOpenTermsModal }) => {
  return (
    <Modal
      open={openTermsModal}
      onClose={() => setOpenTermsModal(false)}
      aria-labelledby="modal-offerz-plus-tc"
      aria-describedby="modal-offerz-plus-tc-description"
      closeAfterTransition
    >
      <Slide direction="down" in={openTermsModal} mountOnEnter unmountOnExit>
        <Box
          sx={{
            color: "#666",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%) !important",
            bgcolor: "background.paper",
            boxShadow: 24,
            px: "20px",
            pb: "20px",
            borderRadius: 2,
            maxWidth: { xs: "90%", md: "600px" },
            width: "100%",
            outline: "none !important",
            maxHeight: "90%",
            overflow: "auto",
            fontSize: "14px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between",
              py: "15px",
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: "17px" }}>
              <Trans>Geschäftsbedingungen</Trans>
            </Typography>
            <Button
              onClick={() => setOpenTermsModal(false)}
              sx={{
                height: "auto",
                minWidth: "unset",
                color: "#000",
                opacity: 0.5,
                p: 0,
                "&:hover": { opacity: 1 },
              }}
            >
              <CloseIcon />
            </Button>
          </Box>
          <Divider sx={{ mb: 2 }} />

          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              <Trans>1. Teilnahmebedingungen</Trans>
            </Typography>
            <Typography variant="body2">
              <Trans>
                Bei Offerz Plus dürfen sämtliche Endkunden der Offerz GmbH kostenlos teilnehmen.
                Firmenkunden dürfen am Treueprogramm nicht teilnehmen. Das Mindestalter beträgt 12
                Jahre. Für die Teilnahme bei Offerz Plus wird ein Offerz Konto vorausgesetzt. Die
                vorliegenden AGB&apos;s müssen akzeptiert werden, um teilzunehmen.
              </Trans>
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              <Trans>2. Punkte</Trans>
            </Typography>
            <Typography variant="body2">
              <Trans>
                Mit jedem Einkauf können Offerz Plus teilnehmende Punkte sammeln. Die jeweiligen
                Punkte für Produkte, Produktgruppen, Aktionen etc. sind auf der Offerz Plus
                Startseite im Konto ersichtlich. Die Punkte werden gutgeschrieben, sobald die
                Bestellung komplett geliefert und abgeschlossen ist. Offerz kann Punkte wieder
                belasten bzw. freiwillig gutschreiben, sofern entsprechende Gründe dafür vorliegen.
                Die Punkte, die sammelbar sind, können jederzeit ändern und variieren und können
                auch für Kunden unterschiedlich ausfallen.
              </Trans>
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              <Trans>3. Quests</Trans>
            </Typography>
            <Typography variant="body2">
              <Trans>
                Quests sind ähnlich wie Stempelkarten, bei welchen man aktiv teilnehmen muss und in
                einem gewissen Zeitraum eine Mission/Quest erfüllen muss, um die entsprechende
                Belohnung (Punkte, Punktevervielfachung oder Prämie) zu erhalten. Die Belohnung muss
                in jedem Fall manuell abgeholt bzw. aktiviert werden. Eine automatische Gutschrift
                erfolgt nicht. Sobald die Quest erfüllt ist, kann die Belohnung abgeholt werden. Es
                gelten jeweils die ausgewiesenen Laufzeiten, in denen die Quests erfüllt werden
                müssen. Es können für Kunden unterschiedliche Quests zur Verfügung stehen.
              </Trans>
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              <Trans>4. Prämien</Trans>
            </Typography>
            <Typography variant="body2">
              <Trans>
                Prämien sind geldähnliche Leistungen, die entweder von Offerz oder durch einen
                Partner zur Verfügung gestellt werden. Die Offerz Plus Mitglieder können diese
                Prämien mit ihren gesammelten Punkten erwerben. Prämien sind nicht entgeltlich
                kaufbar. Die Prämien sind jeweils solange Vorrat bzw. bis zum angegebenen Datum
                verfügbar. Ist eine Prämie nicht mehr verfügbar, wird sie ausgeblendet. Die Prämien
                haben ein Verfallsdatum und sind bis zu diesem einlösbar. Die Prämien können z.B.
                Rabatte bei Offerz, Gratis-Produkte bei Offerz, Rabatte bei Partnern (CHF oder %),
                Gewinnspiele und auch physische Prämien sein. Die Prämien sind jeweils beschrieben,
                wie und wo diese einzulösen sind. Grundsätzlich sind Prämien digital, anderes ist
                vermerkt. Es besteht kein Recht, eine beworbene Prämie zu erhalten, wenn diese nicht
                mehr verfügbar ist. Für die Einlösung von Prämien bei Partnern sind ebendiese
                zuständig.
              </Trans>
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              <Trans>5. Slotmaschine</Trans>
            </Typography>
            <Typography variant="body2">
              <Trans>
                Kunden können zu bestimmten Zeiten an der Slotmaschine ihre Punkte setzen. Die
                Slotmaschine basiert auf dem Zufallsprinzip mit vordefinierten Gewinnchancen und
                Preisen, welche per Zufall verlost werden. Die Vergabe erfolgt automatisch. Offerz
                hat das Recht, bis max. 24 Stunden nach einem Gewinn eine allfällige Korrektur
                vorzunehmen, sollten technische Fehler etc. vorliegen. Der Preis pro Spiel ist
                jeweils angegeben.
              </Trans>
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              <Trans>6. Marketing</Trans>
            </Typography>
            <Typography variant="body2">
              <Trans>
                Offerz Plus Kunden willigen ein, dass wir Sie mittels E-Mails und Push Nachricht
                (App) sowie SMS über neue Prämien, Änderungen, Sortimentsneuheiten, Aktionen und
                andere Angebote informieren können. Sie willigen zudem ein, dass Wohnort, ggf. Alter
                und Geschlecht mit einigen Partnern geteilt werden können in anonymer Form (ohne
                Rückschluss auf den Kunden).
              </Trans>
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              <Trans>7. Sonstiges</Trans>
            </Typography>
            <Typography variant="body2">
              <Trans>
                Die Kunden haben immer in Ihrem Konto unter Offerz Plus die Übersicht über den
                aktuellen Punktestand. Allfällige Probleme/Fehler müssen die Kunden spätestens
                innert 24 Stunden ab Ereignis dem Kundendienst melden. Später besteht kein Anspruch
                mehr auf Korrektur. Sollte ein Missbrauch, Manipulation etc. festgestellt werden,
                ist Offerz berechtigt, den Kunden von Offerz Plus auszuschließen und die Punkte auf
                0 zu setzen, sowie im Notfall das Kundenkonto zu sperren. Es besteht kein
                Rechtsanspruch auf die ausgewiesenen Prämien und Punkte haben keinen Geldwert.
              </Trans>
            </Typography>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};

export default OfferzPlusTC;
